import React, { useEffect, useState } from "react";
import { CheckIcon } from "lucide-react";
import { useHackathon } from "../contexts/HackathonContext";
import type { GroupProfile } from "../types/hackathon";
export function ProductBriefForm({
  group
}: {
  group: GroupProfile;
}) {
  const {
    updateGroup
  } = useHackathon();
  const [draft, setDraft] = useState({
    productName: group.productName,
    tagline: group.tagline,
    problem: group.problem
  });
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    setDraft({
      productName: group.productName,
      tagline: group.tagline,
      problem: group.problem
    });
  }, [group.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const dirty = draft.productName !== group.productName || draft.tagline !== group.tagline || draft.problem !== group.problem;
  const save = (e: React.FormEvent) => {
    e.preventDefault();
    updateGroup(group.id, {
      productName: draft.productName.trim(),
      tagline: draft.tagline.trim(),
      problem: draft.problem.trim()
    });
    setSaved(true);
    setTimeout(() => setSaved(false), 1600);
  };
  const inputClass = "mt-1.5 w-full rounded-lg border border-line bg-surface px-3 py-2 text-[15px] outline-none transition-colors duration-150 placeholder:text-muted/60 focus:border-ink";
  return <form onSubmit={save} className="space-y-4" data-id="element-197" data-mp="1xcnrkq4gdte1">
      <label className="block" data-id="element-198" data-mp="1xcxjij926amd">
        <span className="text-sm font-medium" data-id="element-199" data-mp="1xal52g2ieie2">Product name</span>
        <input value={draft.productName} onChange={e => setDraft({
        ...draft,
        productName: e.target.value
      })} placeholder="e.g. GuardianBand" className={inputClass} data-id="element-200" data-mp="19ncx1qdp4v8c" />
      </label>
      <label className="block" data-id="element-201" data-mp="1jeg02xq6rka9">
        <span className="text-sm font-medium" data-id="element-202" data-mp="1eleg4bb4gujt">One-line pitch</span>
        <input value={draft.tagline} onChange={e => setDraft({
        ...draft,
        tagline: e.target.value
      })} placeholder="What it does, for whom, in one sentence" className={inputClass} data-id="element-203" data-mp="1ek3b685xxgr4" />
      </label>
      <label className="block" data-id="element-204" data-mp="2m09z0hh1ivqk">
        <span className="text-sm font-medium" data-id="element-205" data-mp="2lz8elme4www6">Problem it solves</span>
        <textarea rows={3} value={draft.problem} onChange={e => setDraft({
        ...draft,
        problem: e.target.value
      })} placeholder="Who has the problem and why it matters" className={`${inputClass} resize-none`} data-id="element-206" data-mp="2qxjpm0g61dfz" />
      </label>
      <div className="flex items-center justify-end gap-3" data-id="element-207" data-mp="2315t3hkspi34">
        {saved && <span className="inline-flex items-center gap-1 text-sm text-brgreen" data-id="element-208" data-mp="27zfre11tgysy">
            <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-209" data-mp="281k51apipc6f" />
            Saved
          </span>}
        <button type="submit" disabled={!dirty} className="rounded-xl bg-ink px-4 py-2 text-sm font-semibold text-white transition-[transform,background-color] duration-150 hover:bg-ink/90 active:scale-[0.97] disabled:cursor-not-allowed disabled:bg-ink/30" data-id="element-210" data-mp="2h0dxcovtfge6">
          Save brief
        </button>
      </div>
    </form>;
}